const initContactForm = () => {
    const prenomField = document.getElementById('contact_prenom');
    const nomField = document.getElementById('contact_nom');
    const emailField = document.getElementById('contact_email');
    const messageContainer = document.getElementById('contact-message-container');
    const entrepriseForm = document.querySelector('#new_entreprise');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!prenomField || !nomField || !emailField || !messageContainer) return;

    const junior = document.querySelector('meta[name="junior-id"]')?.content;
    if (!junior) return;

    const checkEmailFormat = (email) => emailRegex.test(email);

    const checkUniqueness = () => {
        const prenom = prenomField.value;
        const nom = nomField.value;
        const email = emailField.value;

        document.getElementById('email-error-message')?.remove();

        fetch(`/juniors/${junior}/contacts/verify?prenom=${prenom}&nom=${nom}&email=${email}`)
            .then((response) => {
                if (!response.ok) throw new Error('Erreur réseau');
                return response.json();
            })
            .then((data) => {
                messageContainer.innerHTML = '';
                if (data.email_exists || data.nom_prenom_exists) {
                    const message = 'Un contact a été trouvé avec les mêmes informations.';
                    const button = `<a href="/juniors/${junior}/contacts/${data.contact}" class="btn btn-info">Voir le contact</a>`;
                    messageContainer.innerHTML = `<div>${message}</div>${button}`;
                }
            })
            .catch((error) => {
                console.error('Erreur fetch:', error);
            });

        if (!checkEmailFormat(email) && email.trim() !== "") {
            const errorMessage = document.createElement('div');
            errorMessage.id = 'email-error-message';
            errorMessage.textContent = "L'adresse e-mail n'est pas valide.";
            errorMessage.className = 'email-error';
            emailField.parentNode.insertBefore(errorMessage, emailField.nextSibling);
        }
    };

    prenomField.addEventListener('blur', checkUniqueness);
    nomField.addEventListener('blur', checkUniqueness);
    emailField.addEventListener('blur', checkUniqueness);

    if (entrepriseForm) {
        console.log('Entreprise form initialized');
        entrepriseForm.addEventListener('ajax:success', (event) => {
            console.log('Entreprise form submitted successfully');
            const [data] = event.detail;
            const entrepriseSelect = document.querySelector('#contact_entreprise_id');
            const newOption = new Option(data.nom, data.id, true, true);
            entrepriseSelect.add(newOption);
            document.getElementById("bottom-panel")?.classList.remove('active');
            document.getElementById("overlay2")?.classList.remove('active');
        });
        entrepriseForm.addEventListener('ajax:error', (event) => {
            console.log('Erreur lors de la création de l’entreprise');
            const [data] = event.detail;
            const errorContainer = document.querySelector('#entreprise-error-container');
            if (errorContainer) {
                errorContainer.innerHTML = '';
                if (data?.errors) {
                    const list = data.errors.map((err) => `<li>${err}</li>`).join('');
                    errorContainer.innerHTML = `<ul class="error-list">${list}</ul>`;
                } else {
                    errorContainer.innerHTML = `<p>Une erreur est survenue.</p>`;
                }
            } else {
                alert(data?.errors?.join('\n') || 'Erreur lors de la création.');
            }
        });
    }
};

export { initContactForm };
